import {
  initialState,
  Actions,
  State,
  NEW_ANSWER_QUIZ,
  NEW_ANSWER_QUIZ_SUCCESS,
  NEW_ANSWER_QUIZ_ERROR,
  RESET_NEW_ANSWER_QUIZ,
} from "../../types/quiz/new-answer-quiz.dto";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_ANSWER_QUIZ:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case NEW_ANSWER_QUIZ_SUCCESS:
      return {
        ...state,
        data: JSON.parse(JSON.stringify(action.payload)),
        states: {
          loading: false,
          success: true,
          error: false,
        },
      };
    case NEW_ANSWER_QUIZ_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    case RESET_NEW_ANSWER_QUIZ:
      return {
        ...initialState
      }
    default:
      return { ...state };
  }
};

export default reducers;
